import { useEffect, useState } from 'react'
import { LayoutGrid } from 'lucide-react'
import { FormDrawer } from '../../components/Drawer'
import { FormBody, SwitchField } from '../../components/Form'
import GroupPicker from '../../components/GroupPicker'
import { strings as S } from './strings'

const D = S.detail.groupsPanel

/**
 * الإدارات — which departments a programme is assigned to.
 *
 * The card beside it has always said whether a programme has any; this is the way in. One
 * `SaveProgramGroups` call, which takes the whole list rather than a diff, so what is ticked
 * here IS the assignment afterwards.
 */
export default function ProgramGroupsDrawer({ open, program, groups, saving, onClose, onSave }) {
  const [selected, setSelected] = useState([])
  const [assignNew, setAssignNew] = useState(false)

  useEffect(() => {
    if (!open) return
    setSelected((program?.groupIds ?? []).map(String))
    setAssignNew(Boolean(program?.assignToNewIntegratedGroups))
  }, [open, program])

  return (
    <FormDrawer
      open={open}
      size="md"
      formId="program-groups"
      icon={LayoutGrid}
      title={D.title}
      subtitle={program?.name}
      submitLabel={S.form.save}
      cancelLabel={S.close}
      /* `SaveProgramGroups` refuses an empty list with a bare "Input not valid", so the
         save is held rather than letting that be the answer. The legacy guards the same
         way, with its own message. */
      submitting={saving || selected.length === 0}
      onClose={onClose}
      onSubmit={(event) => {
        event.preventDefault()
        onSave({ groupIds: selected.map(Number), assignToNewIntegratedGroups: assignNew })
      }}
    >
      <FormBody>
        <GroupPicker
          options={groups}
          selected={selected}
          onChange={setSelected}
          legend={D.legend}
          error={selected.length === 0 ? D.noneChosen : undefined}
          selectAllLabel={D.selectAll}
          filterLabel={D.filter}
        />
        {/* The legacy's own switch: a department created by the directory sync after this
            programme was saved is assigned to it too. */}
        <SwitchField
          checked={assignNew}
          onChange={setAssignNew}
          label={D.assignNew}
          hint={D.assignNewHint}
        />
      </FormBody>
    </FormDrawer>
  )
}
